import { NgModule } from '@angular/core';
import { CommonModule as AngularCore } from '@angular/common';
// eslint-disable-next-line td-wb-rules/uirouter-import-rule
import { UIRouterModule } from '@uirouter/angular';

import { CoreModule } from '@tdwb/core';

import { TradingRoutes } from './trading.routes';
import { OrderNotificationsToastModule } from './order-notifications-toast/order-notifications-toast.module';

@NgModule({
  imports: [
    AngularCore,
    UIRouterModule.forChild({
      states: TradingRoutes.states
    }),
    CoreModule,
    OrderNotificationsToastModule
  ],
  exports: [
    OrderNotificationsToastModule
  ]
})
export class TradingModule {
}

export {
  OrderNotificationsToastModule
};
